import { useState, useEffect } from "react";
import styles from "./MoneyActionModal.module.css";
import { API_URL } from '../../config/api';


const MoneyActionModal = ({ wallet, type, onClose, onSuccess }) => {
  const [amount, setAmount] = useState("");
  const token = localStorage.getItem("token"); // ✅ Берём токен

  useEffect(() => {
    setAmount("");
  }, [wallet, type]);

  if (!wallet) return null;

  const isDeposit = type === "deposit";

  const handleSubmit = async () => {
    const value = Number(amount);
    if (!value || value <= 0) {
      alert("Введите корректную сумму");
      return;
    }

    if (!token) {
      console.error("❌ Нет токена! Авторизация не выполнена.");
      alert("Ошибка авторизации");
      return;
    }

    const url = `${API_URL}/api/wallets/${wallet.id}/${isDeposit ? "deposit" : "withdraw"}`;
    const payload = { amount: value };

    console.log(`📤 Отправляем ${isDeposit ? "внесение" : "изъятие"} на сервер:`, payload);

    try {
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      console.log("POST status:", res.status);

      const data = await res.json();
      console.log("POST response:", data);

      if (!res.ok) {
        console.error("❌ Ошибка при операции:", data);
        alert(`Ошибка (${res.status}): ${data.message || "Неизвестная ошибка"}`);
        return;
      }

      if (onSuccess) onSuccess(data); // 🔹 Передаем результат родителю
      onClose();
    } catch (err) {
      console.error("💥 Ошибка при выполнении POST-запроса:", err);
      alert(`Ошибка: ${err.message}`);
    }
  };

  // 🔹 Обработчик для Enter
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && amount.trim() !== "") {
      handleSubmit();
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h3 className={styles.title}>
            {isDeposit ? "Внесение денег" : "Изъятие денег"}
          </h3>
        </div>

        <div className={styles.info}>
          <div className={styles.infoLabel}>Движение денег</div>
          <div className={styles.balance}>
            Сумма на счёте
            <span className={styles.balanceValue}>
              {Number(wallet.balance || 0).toLocaleString()} ₸
            </span>
          </div>
        </div>

        <div className={styles.inputBlock}>
          <label className={styles.inputLabel}>Сумма</label>
          <input
            type="number"
            className={styles.input}
            placeholder="Введите сумму"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            onKeyDown={handleKeyDown} // ✅ Enter срабатывает
          />
        </div>

        <div className={styles.actions}>
          <button className={styles.cancelButton} onClick={onClose}>
            Отмена
          </button>

          <button
            className={isDeposit ? styles.depositButton : styles.withdrawButton}
            onClick={handleSubmit}
          >
            {isDeposit ? "Пополнить" : "Изъять"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MoneyActionModal;
